/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmUsageClassify } from "../../funcs/llmUsageClassify.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetClassifyUsageRequest$inboundSchema,
};

export const tool$llmUsageClassify: ToolDefinition<typeof args> = {
  name: "llm-usage-classify",
  description: `Get classify usage

Retrieve usage metrics for classify operations.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmUsageClassify(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
